<h2 mat-dialog-title>{{ title }}</h2>

<div mat-dialog-content class="user-select-dialog-content">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search users</mat-label>
    <input matInput [formControl]="control" [matAutocomplete]="auto" placeholder="Type a name" />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="selectUser($event.option.value)">
      @if (filteredUsers$ | async; as list) {
        @for (u of list; track u.id) {
          <mat-option [value]="u">
            <div class="user-option">
              <div class="name">{{ u.name }}</div>
              @if (u.email) {
                <div class="email">{{ u.email }}</div>
              }
            </div>
          </mat-option>
        }
        @if (list.length === 0) {
          <mat-option disabled>No matching users</mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (users?.length === 0 && !selectedUser) {
    <div class="loading">Loading users…</div>
  }

  @if (selectedUser) {
    <div class="selected-preview">
      <div class="selected-title">Selected user</div>
      <div class="selected-card">
        <div class="initial">{{ (selectedUser.name || '?').charAt(0) }}</div>
        <div class="info">
          <div class="name">{{ selectedUser.name }}</div>
          @if (selectedUser.email) {
            <div class="email">{{ selectedUser.email }}</div>
          }
        </div>
      </div>
    </div>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!selectedUser" (click)="save()">Select</button>
</div>
